import { render, staticRenderFns } from "./hashtag.vue?vue&type=template&id=50687572"
import script from "./hashtag.vue?vue&type=script&lang=js"
export * from "./hashtag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50687572')) {
      api.createRecord('50687572', component.options)
    } else {
      api.reload('50687572', component.options)
    }
    module.hot.accept("./hashtag.vue?vue&type=template&id=50687572", function () {
      api.rerender('50687572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stiker/hashtag.vue"
export default component.exports